export default "__VITE_ASSET__5aRZ6od5__"